// UserContext.js

import React, { createContext, useReducer, useEffect } from 'react';
import { profileAdmin } from '../api/service'; // Import your API service

const initialState = {
  user: {},
  isLoading: true,
  error: null,
};

const UserContext = createContext(initialState);

const userReducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_SUCCESS':
      return {
        ...state,
        user: action.payload,
        isLoading: false,
        error: null,
      };
    case 'FETCH_ERROR':
      return {
        ...state,
        user: {},
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(userReducer, initialState);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      profileAdmin(token)
        .then((response) => {
          if (response.data.status !== 'failed') {
            dispatch({ type: 'FETCH_SUCCESS', payload: response.data.adminValidation });
          } else {
            localStorage.removeItem('token');
            dispatch({ type: 'FETCH_ERROR', payload: 'Failed to fetch user data' });
          }
        })
        .catch((error) => {
          dispatch({ type: 'FETCH_ERROR', payload: error.message });
        });
    } else {
      dispatch({ type: 'FETCH_ERROR', payload: 'No token found' });
    }
  }, []);

  return <UserContext.Provider value={state}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = React.useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
